export const GETPROFILEPIC = "GETPROFILEPIC";
export const GETPROFILEPIC_ERROR = "GETPROFILEPIC_ERROR";
export const GETPROFILEPIC_HIDE_ERROR = "GETPROFILEPIC_HIDE_ERROR";
export const GETPROFILEPIC_START_LOADER = "GETPROFILEPIC_START_LOADER";
export const GETPROFILEPIC_STOP_LOADER = "GETPROFILEPIC_STOP_LOADER";
